import municipios from "./municipios";

export const $constants = {
  tiposDeMediacaoDidaticoPedagogica: ["Presencial", "Semipresencial", "Educação a distância – EAD"],
  localDeFuncionamentoDiferenciadoDaTurma: [
    "Sala anexa",
    "Unidade de atendimento socioeducativo",
    "Unidade prisional",
    "A turma não está em local de funcionamento diferenciado",
  ],
  diasDaSemana: [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
  ],
  tiposDeAtendimento: [
    "Escolarização",
    "Atendimento educacional especializado (AEE)",
    "Atividade complementar",
  ],
  modalidades: [
    "Ensino regular",
    "Educação especial - modalidade substitutiva",
    "Educação de jovens e adultos",
    "Educação profissional",
  ],
  tipoPessoa: ["Pessoa Física", "Pessoa Jurídica"],
  orgaosEmissores: [
    {
      id: 1,
      sigla: "SSP",
      descricao: "Secretaria de Segurança Pública",
    },
    {
      id: 2,
      sigla: "PM",
      descricao: "Polícia Militar",
    },
    {
      id: 3,
      sigla: "PC",
      descricao: "Polícia Civil",
    },
    {
      id: 4,
      sigla: "CNH",
      descricao: "Carteira Nacional de Habilitação",
    },
    {
      id: 5,
      sigla: "DIC",
      descricao: "Diretoria de Identificação Civil",
    },
    {
      id: 6,
      sigla: "CTPS",
      descricao: "Carteira de Trabaho e Previdência Social",
    },
    {
      id: 7,
      sigla: "FGTS",
      descricao: "Fundo de Garantia do Tempo de Serviço",
    },
    {
      id: 8,
      sigla: "IFP",
      descricao: "Instituto Félix Pacheco",
    },
    {
      id: 9,
      sigla: "IPF",
      descricao: "Instituto Pereira Faustino",
    },
    {
      id: 10,
      sigla: "IML",
      descricao: "Instituto Médico-Legal",
    },
    {
      id: 11,
      sigla: "MTE",
      descricao: "Ministério do Trabalho e Emprego",
    },
    {
      id: 12,
      sigla: "MMA",
      descricao: "Ministério da Marinha",
    },
    {
      id: 13,
      sigla: "MAE",
      descricao: "Ministério da Aeronáutica",
    },
    {
      id: 14,
      sigla: "MEX",
      descricao: "Ministério do Exército",
    },
    {
      id: 15,
      sigla: "POF",
      descricao: "Polícia Federal",
    },
    {
      id: 16,
      sigla: "POM",
      descricao: "Polícia Militar",
    },
    {
      id: 17,
      sigla: "SES",
      descricao: "Carteira de Estrangeiro",
    },
    {
      id: 18,
      sigla: "SJS",
      descricao: "Secretaria da Justiça e Segurança",
    },
    {
      id: 19,
      sigla: "SJTS",
      descricao: "Secretaria da Justiça do Trabalho e Segurança",
    },
    {
      id: 20,
      sigla: "ZZZ",
      descricao: "Outros (inclusive exterior)",
    },
  ],
  situacoesMatricula: [
    "CURSANDO",
    // "APROVADO",
    "INATIVO",
    // "REPROVADO",
    "FALECIDO",
    "ABANDONO",
    "TRANSFERIDO",
    "CANCELADO",
    "TROCA DE TURMA",
    "TRANSFERIDO OUTROS",
    "RECEBIDA",
  ],

  situacoesUsuarios: [
    {
      descricao: "ATIVO",
      cor: "success",
    },
    {
      descricao: "BLOQUEADO",
      cor: "error",
    },
  ],

  situacoesMatriculaCondition: {
    CURSANDO: false,
    INATIVO: true,
    FALECIDO: true,
    ABANDONO: true,
    TRANSFERIDO: true,
    CANCELADO: true,
    TROCA_DE_TURMA: true,
    TRANSFERIDO_OUTROS: true,
  },

  vinculo: [
    {
      desc: "Efetivo",
      value: 0,
    },
    {
      desc: "Celetista",
      value: 1,
    },
  ],

  bimestres: [
    {
      desc: "1° bimestre",
      value: 0,
    },
    {
      desc: "2° bimestre",
      value: 1,
    },
    {
      desc: "3° bimestre",
      value: 2,
    },
    {
      desc: "4° bimestre",
      value: 3,
    },
  ],

  tipos_pesquisa_aluno: [
    {
      desc: "Pai",
      value: "filiacao2",
    },
    {
      desc: "Mãe",
      value: "filiacao1",
    },
    {
      desc: "Data de nasc",
      value: "data_nascimento",
    },
    {
      desc: "Sexo",
      value: "sexo_id",
    },
    {
      desc: "Cor/Raça",
      value: "cor_ou_raca",
    },
    {
      desc: "Nacionalidade",
      value: "naturalidade",
    },
    {
      desc: "País de nacionalidade",
      value: "nacionalidade",
    },
    {
      desc: "UF de nascimento",
      value: "estadualidade",
    },
  ],
  meses: [
    {
      descricao: "Janeiro",
      id: 1,
    },
    {
      descricao: "Fevereiro",
      id: 2,
    },
    {
      descricao: "Março",
      id: 3,
    },
    {
      descricao: "Abril",
      id: 4,
    },
    {
      descricao: "Maio",
      id: 5,
    },
    {
      descricao: "Junho",
      id: 6,
    },
    {
      descricao: "Julho",
      id: 7,
    },
    {
      descricao: "Agosto",
      id: 8,
    },
    {
      descricao: "Setembro",
      id: 9,
    },
    {
      descricao: "Outubro",
      id: 10,
    },
    {
      descricao: "Novembro",
      id: 11,
    },
    {
      descricao: "Dezembro",
      id: 12,
    },
  ],

  planos: [
    {
      descricao: "Bimestral",
      route: "gestoesDeAulas.planoBimestralCreate",
    },
    {
      descricao: "Bimestral infantil",
      route: "gestoesDeAulas.planoBimestralCreate",
    },
  ],

  planosForm: [
    {
      descricao: "Unidades tématicas / práticas de linguagem",
      form: "tematica",
      abreviacao: "UNID TEM/PRAT. LING",
    },
    {
      descricao: "OBJETOS DO CONHECIMENTO",
      form: "objeto_conhecimento",
      abreviacao: "OBJ CONH.",
    },
    {
      descricao: "HABILIDADES",
      form: "habilidades",
      abreviacao: "HAB",
    },
    {
      descricao: "ODS",
      form: "ods",
      abreviacao: "ODS",
    },
    {
      descricao: "METODOLOGIA",
      form: "metodologia",
      abreviacao: "METOD",
    },
    {
      descricao: "RECURSOS DIDÁTICOS",
      form: "recursos_didaticos",
      abreviacao: "REC DIDAT",
    },
    {
      descricao: "AVALIAÇÃO DA APRENDIZAGEM",
      form: "avaliacao_aprendizagem",
      abreviacao: "AVAL. APREND",
    },
    {
      descricao: "REFERÊNCIAS",
      form: "referencias",
      abreviacao: "REF.",
    },
  ],

  planosBimestraisForm: [
    {
      descricao: "UNIDADE TEMÁTICA",
      form: "unidades_tematicas",
    },
    {
      descricao: "OBJETO DE CONHECIMENTO",
      form: "objeto_conhecimento",
    },
    {
      descricao: "HABILIDADES (código alfanumérico BNCC)",
      form: "habilidades",
    },
    {
      descricao: "ABORDAGEM PEDAGÓGICA",
      form: "abordagem_pedagogica",
    },
    {
      descricao: "RECURSOS DIDÁTICOS",
      form: "recursos_didaticos",
    },
    {
      descricao: "PROCESSOS AVALIATIVOS",
      form: "processos_avaliativos",
    },
  ],

  planosBimestraisInfantil: [
    {
      descricao: "ATIVIDADE/POSSIBILIDADE DE EXPERIÊNCIA",
      form: "atividade_de_experiencia",
    },
    {
      descricao: "DIREITOS DE APREDIZAGEM",
      form: "direito_aprendizagem",
    },
    {
      descricao: "CAMPOS DE EXPERIÊNCIA",
      form: "campos_de_experiencia",
    },
    {
      descricao: "CÓDIGO ALFANUMERICO COM OBJETIVO",
      form: "codigo_alfanumerico",
    },
    {
      descricao: "RECURSOS",
      form: "recursos",
    },
    {
      descricao: "AVALIAÇÃO",
      form: "avaliacao",
    },
    {
      descricao: "REFERÊNCIA",
      form: "referencia",
    },
  ],

  sistemaDeNotas: ["Numerica", "Relatório Infantil", "Relatório Individual"],
  atividadesComplementaresList: [
    {
      codigo: 11002,
      descricao: "Canto coral",
    },
    {
      codigo: 11006,
      descricao: "Banda",
    },
    {
      codigo: 11011,
      descricao: "Iniciação Musical",
    },
    {
      codigo: 12003,
      descricao: "Desenho",
    },
    {
      codigo: 12004,
      descricao: "Escultura e Cerâmica",
    },
    {
      codigo: 12005,
      descricao: "Grafite",
    },
    {
      codigo: 12007,
      descricao: "Pintura",
    },
    {
      codigo: 13001,
      descricao: "Cineclube",
    },
    {
      codigo: 14001,
      descricao: "Teatro",
    },
    {
      codigo: 14002,
      descricao: "Danças",
    },
    {
      codigo: 14004,
      descricao: "Práticas Circenses",
    },
    {
      codigo: 15001,
      descricao: "Capoeira",
    },
    {
      codigo: 15002,
      descricao: "Artesanato",
    },
    {
      codigo: 15003,
      descricao: "Brinquedos",
    },
    {
      codigo: 15004,
      descricao: "Contos",
    },
    {
      codigo: 16001,
      descricao: "Educação Patrimonial",
    },
    {
      codigo: 17004,
      descricao: "Leitura",
    },
    {
      codigo: 17002,
      descricao: "Línguas Estrangeiras",
    },
    {
      codigo: 19999,
      descricao: "Outra categoria de Cultura, Artes e Educação Patrimonial",
    },
    {
      codigo: 21001,
      descricao: "Recreação (Brinquedoteca e Jogos)",
    },
    {
      codigo: 22007,
      descricao: "Yoga",
    },
    {
      codigo: 22009,
      descricao: "Tênis de campo",
    },
    {
      codigo: 22011,
      descricao: "Atletismo",
    },
    {
      codigo: 22012,
      descricao: "Badminton",
    },
    {
      codigo: 22014,
      descricao: "Basquete",
    },
    {
      codigo: 22015,
      descricao: "Ciclismo",
    },
    {
      codigo: 22018,
      descricao: "Futebol",
    },
    {
      codigo: 22019,
      descricao: "Futsal",
    },
    {
      codigo: 22020,
      descricao: "Ginástica(rítmica, artística, acrobática)",
    },
    {
      codigo: 22021,
      descricao: "Handebol",
    },
    {
      codigo: 22022,
      descricao: "Judô",
    },
    {
      codigo: 22023,
      descricao: "Karatê",
    },
    {
      codigo: 22024,
      descricao: "Luta Olímpica",
    },
    {
      codigo: 22025,
      descricao: "Natação",
    },
    {
      codigo: 22026,
      descricao: "Taekwondo",
    },
    {
      codigo: 22027,
      descricao: "Tênis de Mesa",
    },
    {
      codigo: 22028,
      descricao: "Voleibol",
    },
    {
      codigo: 22029,
      descricao: "Vôlei de Praia",
    },
    {
      codigo: 22030,
      descricao: "Xadrez Tradicional/xadrez virtual",
    },
    {
      codigo: 29999,
      descricao: "Outra categoria de Esporte e Lazer",
    },
    {
      codigo: 22025,
      descricao: "Natação",
    },
    {
      codigo: 31002,
      descricao: "Português",
    },
    {
      codigo: 31001,
      descricao: "Matemática",
    },
    {
      codigo: 39999,
      descricao: "Outra categoria de Acompanhamento Pedagógico",
    },
    {
      codigo: 41007,
      descricao: "Educação em Direitos Humanos",
    },
    {
      codigo: 71007,
      descricao: "Promoção da Saúde",
    },
    {
      codigo: 10103,
      descricao: "Iniciação Científica",
    },
    {
      codigo: 13301,
      descricao: "Educação Ambiental e Desenvolvimento Sustentável",
    },
    {
      codigo: 13108,
      descricao: "Economia Solidária e Criativa/Educação Econômica (Educação Financeira e Fiscal)",
    },
    {
      codigo: 14101,
      descricao: "Fotografia",
    },
    {
      codigo: 14102,
      descricao: "História em Quadrinhos",
    },
    {
      codigo: 14103,
      descricao: "Jornal Escolar",
    },
    {
      codigo: 14104,
      descricao: "Rádio Escolar",
    },
    {
      codigo: 22025,
      descricao: "Vídeo",
    },
    {
      codigo: 14201,
      descricao: "Robótica Educacional",
    },
    {
      codigo: 14202,
      descricao: "Tecnologias Educacionais",
    },
    {
      codigo: 14203,
      descricao: "Ambientes de Redes Sociais",
    },
    {
      codigo: 14999,
      descricao: "Outra Categoria de Comunicação, Uso de Mídias e Cultura Digital e Tecnológica",
    },
    {
      codigo: 15101,
      descricao: "Memória e História das Comunidades Tradicionais",
    },
  ],
  sexoList: [
    {
      id: 1,
      descricao: "Masculino",
    },
    {
      id: 2,
      descricao: "Feminino",
    },
  ],
  corOuRacaList: ["Branca", "Preta", "Parda", "Amarela", "Indígena", "Não declarada"],
  nacionalidadeList: [
    "Brasileira",
    "Brasileira – nascido no exterior ou naturalizado",
    "Estrangeira",
  ],
  tipoSanguineoList: [
    { id: 1, descricao: "A+" },
    { id: 2, descricao: "B+" },
    { id: 3, descricao: "AB+" },
    { id: 4, descricao: "O+" },
    { id: 5, descricao: "A-" },
    { id: 6, descricao: "B-" },
    { id: 7, descricao: "O-" },
    { id: 8, descricao: "AB-" },
  ],
  religioesList: [
    { id: 1, descricao: "Catolicismo", situacao: "0" },
    { id: 2, descricao: "Protestantismo", situacao: "0" },
    { id: 3, descricao: "Espiritismo", situacao: "0" },
    { id: 4, descricao: "Umbanda", situacao: "0" },
    { id: 5, descricao: "Candomblé", situacao: "0" },
    { id: 6, descricao: "Judaísmo", situacao: "0" },
    { id: 7, descricao: "Budismo", situacao: "0" },
    { id: 8, descricao: "Testemunha de Jeová", situacao: "0" },
    { id: 9, descricao: "Evangelicalismo", situacao: "0" },
  ],

  estadoCivilList: [
    { id: 1, descricao: "Solteiro" },
    { id: 2, descricao: "Casado" },
    { id: 3, descricao: "Separado" },
    { id: 4, descricao: "Divorciado" },
    { id: 5, descricao: "Viúvo" },
  ],
  estadosList: [
    { id: 1, codigo: "AC", descricao: "Acre", situacao: "0", codigo_ibge: "12" },
    { id: 2, codigo: "AL", descricao: "Alagoas", situacao: "0", codigo_ibge: "27" },
    { id: 3, codigo: "AP", descricao: "Amapá", situacao: "0", codigo_ibge: "16" },
    { id: 4, codigo: "AM", descricao: "Amazonas", situacao: "0", codigo_ibge: "13" },
    { id: 5, codigo: "BA", descricao: "Bahia", situacao: "0", codigo_ibge: "29" },
    { id: 6, codigo: "CE", descricao: "Ceará", situacao: "0", codigo_ibge: "23" },
    { id: 7, codigo: "DF", descricao: "Distrito Federal", situacao: "0", codigo_ibge: "53" },
    { id: 8, codigo: "ES", descricao: "Espírito Santo", situacao: "0", codigo_ibge: "32" },
    { id: 9, codigo: "GO", descricao: "Goiás", situacao: "0", codigo_ibge: "52" },
    { id: 10, codigo: "MA", descricao: "Maranhão", situacao: "0", codigo_ibge: "21" },
    { id: 11, codigo: "MT", descricao: "Mato Grosso", situacao: "0", codigo_ibge: "51" },
    { id: 12, codigo: "MS", descricao: "Mato Grosso do Sul", situacao: "0", codigo_ibge: "50" },
    { id: 13, codigo: "MG", descricao: "Minas Gerais", situacao: "0", codigo_ibge: "31" },
    { id: 14, codigo: "PA", descricao: "Pará", situacao: "0", codigo_ibge: "15" },
    { id: 15, codigo: "PB", descricao: "Paraíba", situacao: "0", codigo_ibge: "25" },
    { id: 16, codigo: "PR", descricao: "Paraná", situacao: "0", codigo_ibge: "41" },
    { id: 17, codigo: "PE", descricao: "Pernambuco", situacao: "0", codigo_ibge: "26" },
    { id: 18, codigo: "PI", descricao: "Piauí", situacao: "0", codigo_ibge: "22" },
    { id: 19, codigo: "RJ", descricao: "Rio de Janeiro", situacao: "0", codigo_ibge: "33" },
    { id: 20, codigo: "RN", descricao: "Rio Grande do Norte", situacao: "0", codigo_ibge: "24" },
    { id: 21, codigo: "RS", descricao: "Rio Grande do Sul", situacao: "0", codigo_ibge: "43" },
    { id: 22, codigo: "RO", descricao: "Rondônia", situacao: "0", codigo_ibge: "11" },
    { id: 23, codigo: "RR", descricao: "Roraima", situacao: "0", codigo_ibge: "14" },
    { id: 24, codigo: "SC", descricao: "Santa Catarina", situacao: "0", codigo_ibge: "42" },
    { id: 25, codigo: "SP", descricao: "São Paulo", situacao: "0", codigo_ibge: "35" },
    { id: 26, codigo: "SE", descricao: "Sergipe", situacao: "0", codigo_ibge: "28" },
    { id: 27, codigo: "TO", descricao: "Tocantins", situacao: "0", codigo_ibge: "17" },
  ],
  municipios,
  tipoDeDeficienciaList: [
    "Baixa visão",
    "Cegueira",
    "Deficiência auditiva",
    "Deficiência física",
    "Deficiência intelectual",
    "Deficiência Múltipla",
    "Epilepsia",
    "Síndrome de Down",
    "Surdez",
    "Surdocegueira",
    "Transtorno do espectro autista",
  ],
  tipoDeTranstornoDoEspectroAutistaList: ["Transtorno do espectro autista"],
  tipoDeAltasHabilidadesList: ["Altas habilidades/Superdotação"],
  recursosSaebList: [
    "Auxílio ledor",
    "Auxílio transcrição",
    "Guia-intérprete",
    "Tradutor-intérprete de Libras",
    "Leitura labial",
    "Prova ampliada (Fonte 18)",
    "Prova superampliada (Fonte 24)",
    "CD com áudio para deficiente visual",
    "Prova de Língua Portuguesa como Segunda Língua para surdos e deficientes auditivos",
    "Prova em Video Libras",
    "Material didático e prova em Braille",
    "Nenhum",
  ],
  zonaResidenciaList: ["Urbana", "Rural"],
  localizacaoDiferenciadaDeResidenciaList: [
    "Não está em área de localização diferenciada",
    "Área onde se localiza comunidade remanescente de quilombos",
    "Terra indígena",
    "Área de assentamento",
  ],
  rolesParaProfessores: [
    {
      id: "2",
      name: "professor",
    },
    {
      id: "5",
      name: "coordenador",
    },
    {
      id: "7",
      name: "direção",
    },
    {
      id: "8",
      name: "supervisor",
    },
  ],

  rolesParaGestores: [
    {
      id: "1",
      name: "admin",
    },
    {
      id: "4",
      name: "secretario",
    },
    {
      id: "6",
      name: "super-admin",
    },
    {
      id: "9",
      name: "tec-admin",
    },
  ],

  tiposDeAulas: [
    "Aula Remota",
    "Aula Normal",
    "Reposição",
    "Aula Extra",
    "Substituição",
    "Aula Antecipada",
    "Atividade Extra-classe",
    "Recuperação",
  ],
  situacoesAulas: [
    {
      descricao: "Aula confirmada",
      cor: "success",
    },
    {
      descricao: "Aguardando confirmação",
      cor: "blue-grey lighten-4",
    },
    {
      descricao: "Aula rejeitada por falta",
      cor: "error",
    },
    {
      descricao: "Aula inválida",
      cor: "brown lighten-3",
    },
    {
      descricao: "Aula em conflito",
      cor: "warning",
    },
  ],
  situacoesAulasTabs: [
    {
      descricao: "Confirmadas",
      cor: "green lighten-4",
      tipo: "Aula confirmada",
    },
    {
      descricao: "Aguardando",
      cor: "blue-grey lighten-4",
      tipo: "Aguardando confirmação",
    },
    {
      descricao: "Rejeitadas",
      cor: "red lighten-4",
      tipo: "Aula rejeitada por falta",
    },
    {
      descricao: "Inválidas",
      cor: "brown lighten-5",
      tipo: "Aula inválida",
    },
    {
      descricao: "Conflitadas",
      cor: "amber lighten-4",
      tipo: "Aula em conflito",
    },
  ],
  situacoesAulasCor: {
    "Aula confirmada": "green lighten-2",
    "Aguardando confirmação": "blue-grey lighten-2",
    "Aula rejeitada por falta": "red lighten-2",
    "Aula inválida": "brown lighten-3",
    "Aula em conflito": "amber lighten-2",
  },
  situacoesAulasCorLight: {
    "Aula confirmada": "green lighten-4",
    "Aguardando confirmação": "blue-grey lighten-4",
    "Aula rejeitada por falta": "red lighten-4",
    "Aula inválida": "brown lighten-5",
    "Aula em conflito": "amber lighten-4",
  },
  subEtapaTipoCampos: [
    {
      descricao: "Valor (Inserir) - Número",
      slug: "valor",
    },
    {
      descricao: "Valor (Inserir) - Texto",
      slug: "valor_texto",
    },
    {
      descricao: "Resultado em número",
      slug: "resultado_em_lote",
    },
    {
      descricao: "Resultado em Texto",
      slug: "resultado_em_texto",
    },
  ],
  situacaoAutorizacao: ["PENDENTE", "RECUSADO", "APROVADO"],
  cores: [
    {
      descricao: "Preto",
      codigo: "#000",
    },
    {
      descricao: "Vermelho",
      codigo: "red",
    },
    {
      descricao: "Azul",
      codigo: "blue",
    },
    {
      descricao: "Amarelo",
      codigo: "yellow",
    },
    {
      descricao: "Verde",
      codigo: "green",
    },
  ],
  listCamposAulasLancadas: {
    conteudo: "Conteúdo",
    objetivos_ou_habilidades: "Objetivos ou Habilidades",
    metodologia: "Metodologia",
    objeto_conhecimento: "Objeto de conhecimento",
    recursos: "Recursos",
    // campos para a criação de aulas infantis
    campos_de_experiencias: "Campos de experiências",
    campos_de_aprendizagem: "Direitos de aprendizagem",
    percurso: "Percursos Metodológicos e Avaliativos",
    procedimentos: "Procedimentos",
    eixos: "Eixos",
    estrategias: "Estrategias",
    atividade_classe: "Atividade de classe",
    atividade_casa: "Atividade de casa",
    observacoes: "Observações",
  },
};

export default (vue) => {
  vue.prototype.$constants = $constants;
};
